<template>
  <div class="row">
    <div class="col col-4" v-for="(feature, index) in features" :key="index">
      <h4>{{ feature.title }}</h4>
      <div
        class="dorm-room-features w-100"
        v-for="item in feature.items"
        :key="item.id"
      >
        <Checkbox
          :value="item.value"
          @update="setValue(feature.key, item.id)"
          >{{ item.title }}</Checkbox
        >
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from '../../components/Checkbox/Checkbox.vue'

export default {
  props: {
    buildFeatures: {
      type: Array,
      default: () => []
    },
    roomFeatures: {
      type: Array,
      default: () => []
    },
    services: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    features() {
      return [
        {
          title: 'Bina Özellikleri',
          key: 'buildFeatures',
          items: this.buildFeatures
        },
        {
          title: 'Oda Özellikleri',
          key: 'roomFeatures',
          items: this.roomFeatures
        },
        {
          title: 'Hizmetler',
          key: 'services',
          items: this.services
        }
      ]
    }
  },
  components: { Checkbox },
  methods: {
    setValue(key, id) {
      this.$emit('update', { key, id })
    }
  }
}
</script>

<style lang="scss" scoped></style>
